import * as React from "react";
import { useDispatch } from "@teamprevent/admin-redux";
import { Button, Form, Loader, Modal } from "semantic-ui-react";
import { useForm } from "react-hook-form";

import { TaskTypes } from "@teamprevent/common/task/taskActions/models";

import { zodResolver } from "@hookform/resolvers/zod";

import { AddBillingTaskFormModel, mapToCreateBillingTaskModel } from "../../../task/billingTask/model";

import { createTask } from "../../../crud/ohCase/actions";
import { TaskType } from "../../../task/model";

import { TasksApi } from "../../tasksApi";

import { billingTaskSchemaFactory } from "./schema";
import { AddBillingTaskForm } from "./addBillingTaskForm";

interface AddBillingTaskModalProps {
    ohCaseId: string;
    customerId: string;
    open: boolean;
    onClose: () => void;
}

export function AddBillingTaskModal(props: AddBillingTaskModalProps) {
    const { ohCaseId, customerId, open, onClose } = props;
    const dispatch = useDispatch();
    const [taskType, setTaskType] = React.useState<TaskType | undefined>(undefined);

    const { register, control, handleSubmit, formState: { errors }, reset } = useForm<AddBillingTaskFormModel>({
        resolver: zodResolver(billingTaskSchemaFactory()),
        defaultValues: { taskCode: undefined, amount: undefined, notes: "" }
    });

    React.useEffect(() => {
        const getTaskTypes = async () => {
            const result = await (new TasksApi().getTaskType(TaskTypes.GeneralBillingTask));
            setTaskType(result);
        };

        if (!taskType) {
            getTaskTypes();
        }

    }, [taskType]);

    const submit = handleSubmit((model) => {
        if (taskType) {
            const createTaskModel = mapToCreateBillingTaskModel(model, taskType, ohCaseId);
            dispatch(createTask(customerId, ohCaseId, createTaskModel));
            closeAndResetForm();
        }
    });

    const closeAndResetForm = React.useCallback(() => {
        reset();
        onClose();
    }, [onClose, reset]);

    if (!taskType)
    {
        return <Loader active />;
    }

    return (
        <Modal as={Form} onSubmit={submit} size="small" open={open} onClose={closeAndResetForm} closeOnDimmerClick={false} >
            <Modal.Header>Add Billing Task</Modal.Header>
            <Modal.Content>
                <AddBillingTaskForm register={register} control={control} errors={errors} subTasks={ taskType.subTasks } />
            </Modal.Content>
            <Modal.Actions>
                <Button type="button" onClick={closeAndResetForm}>Cancel</Button>
                <Button type="submit" content="Add Task" />
            </Modal.Actions>
        </Modal>
    );
};
